
import { create } from "zustand";

const usePublicStore = create((set) => ({
    isMenuShow: 0,
    setIsMenuShow: (isMenuShow) => set(() => ({isMenuShow : isMenuShow })),
}));

export default usePublicStore;
